import { Component } from '@angular/core';
import { Plant } from 'src/app/models/plant.model';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-plants-list',
  templateUrl: './plants-list.component.html',
  styleUrls: ['./plants-list.component.scss']
})
export class PlantsListComponent {
  dtoptions: DataTables.Settings = {};
  plants : Plant[] =[]

  constructor( private plantsService: PlantsService,private router: Router,) 
  {
    
   }
  navigate(TId){
    this.plantsService.setSelectedPlant(TId);
    console.log(TId);
    var id = btoa(TId.toString())
    this.router.navigate(['/component/plants/edit/' + id]);
  }
  
  ngOnInit(): void {

    this.dtoptions={
      pagingType: 'full_numbers'
    };
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.plantsService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
      
    }
    else
    {
      this.plantsService.getAllPlant()
    .subscribe({
        next: (plants)=> {
          this.plants = plants;
         
        },
        error: (response) => {
          console.log(response);
          
        }
      })
    }
    }
  }